import { gql } from '@/lib/graphql/gql'

export const CREATE_DATABASE_OBJECT_STORAGES_QUERY = gql`
  query CreateDatabaseObjectStorages($idCompany: String!) {
    company(id: $idCompany) {
      id
      objectStorages {
        id
        items {
          id
          displayName
          location
          status
        }
      }
    }
  }
`
